import { Component, OnInit } from "@angular/core";
import {  Router } from "@angular/router";
import { GtrakAuthService } from "../../../../../app/features/authentication/services/gtrak-auth.service";
import { ToasterService } from "../../../../common/services/toaster.service";
import { MenuStateService } from "../../../../features/home/services/menu.service";
import { AppMenuItem } from "../../../../../core/app-menu/app-menu";

@Component({
  selector: "app-home-page",
  templateUrl: "home.page.html",
  styleUrls: ["./home.page.scss"],
})
export class HomePage implements  OnInit {
  menuItems:  any; 
  loaded:boolean;
  user:string;
  constructor(
    private router: Router,
    public authService: GtrakAuthService,
    public toasterService: ToasterService,
    private menuStateService: MenuStateService,
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.loaded=false;
    this.user=this.authService.user.name;
  this.menuStateService.menuItems$.subscribe(items => {
    this.menuItems = items;
  });
    this.loaded=true;
  }
  
  
// navigateTo(item: AppMenuItem) {
  
  // const path = this.authService.user.isWearer
  //   ? item.alternativeRoute ?? item.route?.path
  //   : item.route?.path;

  // if (path) {
  //   this.router.navigate([path]);
  // }
// }

navigateTo(item: AppMenuItem) {
  if(item.newImage){
     if (item.alternativeRoute) {
        item.alternativeRoute(); 
     }
  }
  else{
    const path = this.authService.user.isWearer
    ? item.alternativeRoute ?? item.route?.path
    : item.route?.path;

    if (path) {
      this.router.navigate([path]);
      }
   }
  }
}